module.exports = __webpack_public_path__ + "img/img-logo-icon-img.d36cdf36.png";